export default [
  {
    path: '/pms_period',
    name: 'pms_period',
    component: (resolve) => require(['@/modules/pms/pages/period/index'], resolve),
    meta: { title: '周期管理' }
  },
  {
    path: '/pms_sheet',
    name: 'pms_sheet',
    component: (resolve) => require(['@/modules/pms/pages/sheet/index'], resolve),
    meta: { title: '工时查询' }
  },
  {
    path: '/pms_sheet_my',
    name: 'pms-sheet-my',
    component: (resolve) => require(['@/modules/pms/pages/sheet/my'], resolve),
    meta: { title: '我的工时' }
  },
  {
    path: '/pms_project',
    name: 'pms_project',
    component: (resolve) => require(['@/modules/pms/pages/project/index'], resolve),
    meta: { title: '项目管理' }
  },
  {
    path: '/pms_statistics',
    name: 'pms_statistics',
    component: (resolve) => require(['@/modules/pms/pages/statistics/project'], resolve),
    meta: { title: '项目统计' }
  },
  {
    path: '/pms_statistics_project',
    name: 'pms_statistics_project',
    component: (resolve) => require(['@/modules/pms/pages/statistics/index'], resolve),
    meta: { title: '统计查看' }
  },
  {
    path: '/pms_statistics_user',
    name: 'pms_statistics_user',
    component: (resolve) => require(['@/modules/pms/pages/statistics/user'], resolve),
    meta: { title: '统计查看' }
  },
  {
    path: '/pms_tools',
    name: 'pms_tools',
    component: (resolve) => require(['@/modules/pms/pages/tools'], resolve),
    meta: { title: '统计查看' }
  },
  {
    path: '/pms_description',
    name: 'pms_description',
    component: (resolve) => require(['@/modules/pms/pages/description'], resolve),
    meta: { title: '统计查看' }
  }
];
